import React from 'react';

/**
 * Cella di intestazione di tabella con bordo pieno.
 *
 * Include solo `border border-line`: e l'unica parte invariante nelle 123
 * intestazioni su 234 (53%) che usano la griglia a bordo pieno. Le altre
 * si dividono fra bordo parziale (60, border-b) e nessun bordo (51), e
 * restano markup nativo.
 *
 * Padding e allineamento NON sono inclusi: dentro la stessa famiglia si
 * dividono quasi a meta (px-2 py-1 in 71 celle, px-3 py-2 in 52) e
 * l'allineamento e text-left in 117 casi ma text-right in 6. Includerli
 * costringerebbe il chiamante a sovrascriverli, e senza tailwind-merge la
 * precedenza dipenderebbe dall'ordine del CSS generato.
 *
 * className non deve quindi ridefinire spessore o colore del bordo.
 *
 * border-line = border-gray-200
 */
export default function TableHeadCell({ className = '', ...props }) {
  return <th {...props} className={`border border-line ${className}`.trim()} />;
}
